import { createSlice } from "@reduxjs/toolkit";
import { InitialCartoonWithDrawFormData } from "../../ConstantData/InitialData";
import { InitialCartoonWithDrawDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const cartoonWithDrawSlice = createSlice({
  name: "cartoonstock",
  initialState: {
    cartoonWithDrawList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialCartoonWithDrawFormData,
    initialDuplicateData: InitialCartoonWithDrawDuplicateFormData,
  },
  reducers: {
    getAllCartoonWithDraws: (state, action) => {
      state.cartoonWithDrawList = action.payload;
    },
    getCartoonWithDrawDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialCartoonWithDrawFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = {
        ...InitialCartoonWithDrawDuplicateFormData,
      };
    },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustCartoonWithDrawItem: (state, action) => {},
    deleteCartoonWithDraw: () => {},
  },
});

export const cartoonWithDrawSliceAction = cartoonWithDrawSlice.actions;
export default cartoonWithDrawSlice.reducer;
